/**
 * Helpers for DOM-related operations.
 */
export class DomHelper {
    /**
     * Checks if any input-like element is currently focused.
     * This includes INPUT, TEXTAREA, contenteditable elements, and elements with role="textbox".
     *
     * @returns True if an input-like element is focused, false otherwise.
     */
    static isAnyInputElementFocused() {
        const activeElement = document.activeElement;
        return !!(activeElement &&
            (activeElement.tagName === 'INPUT' ||
                activeElement.tagName === 'TEXTAREA' ||
                activeElement.getAttribute('contenteditable') === 'true' ||
                activeElement.getAttribute('role') === 'textbox'));
    }
}
//# sourceMappingURL=domHelpers.js.map